module.exports = __webpack_public_path__ + "fonts/la-solid-900.87292218.woff";